// extracted by mini-css-extract-plugin
module.exports = {"root":"SockyClose_root__aIHWC","light":"SockyClose_light__3OpO4"};